require("./chart");
require("./graphUtils");
var enableForecast = false;
var enableReview = true;
require("./activeFacets");
var facetsToGridParams = require("./services/facetsToGridParamsService");

function ajaxCall(formData) {
  $.ajax({
    dataType: "JSON",
        url: "/transactions-dashboard/get-dashboard-chart-data?" + formData,
    })
    .done(function (response) {
      displayChart(response);
    });
}

function downloadCall(formData) {
  redirectTo("/download-transactions?" + formData);
}

function downloadInterestCall(formData) {
  redirectTo("/download-interest-transactions?" + formData);
}

function redirectTo(u) {
  window.location.href = u;
}

function isInDashboardPage() {
  return $("#dashboard-page").length > 0;
}

if (isInDashboardPage()) {
  var data;
  var count = 0;
  var filterBox = $("#filterBox").val();

  $("#paymentId").css("width", "70%");

  $("#forecast-box").hide();
  $("#includeForecast").on("change", function () {
    if ($(this).prop("checked") == true) {
      enableForecast = true;
    } else {
      enableForecast = false;
      $("#forecast-box").hide();
      $('li[data-facet-id="includeForecast"]').remove();
    }
  });
  var isInternalUser = $("#isInternalUser").val();

  $("#downloadButton").on("click", function (event) {
    event.preventDefault();
    var formData = $("form").serialize();
    formData = formData + "&isInternalUser=" + isInternalUser;
    downloadCall(formData);
  });

  $("#downloadInterestButton").on("click", function (event) {
    event.preventDefault();
    var formData = $("form").serialize();
    formData = formData + "&isInternalUser=" + isInternalUser;

    downloadInterestCall(formData);
  })

  enableReview = $("#hiddenStatus").val() == "true";
  if (enableReview) {
    $("#in-review-box").show();
  }

  $(".data-grid").hide();
}

module.exports = {
  displayChart: function (response) {
    if ($("#includeForecast").prop("checked") != true) {
      enableForecast = false;
      $("#forecast-box").hide();
    } else {
      enableForecast = true;
    }
    //    function displayChart(response){
    var map = new Map();
    map = {};

    var negativeMap = new Map();
    negativeMap = {};

    var approvedMap = new Map();
    var negativeApprovedMap = new Map();

    var clearedMap = new Map();
    var negativeClearedMap = new Map();

    var forecastMap = new Map();
    forecastMap = {};
    var negativeForecastMap = new Map();
    negativeForecastMap = {};

    var jsonArray = response["dashboard-transactions"]["transactions-summary"];
    if (enableReview) {
      map = jsonArray[0]["Positive Being Reviewed"];
      negativeMap = jsonArray[1]["Negative Being Reviewed"];

      function get(k) {
        return map[k];
      }
    }

    approvedMap = jsonArray[2]["Positive Approved"];
    negativeApprovedMap = jsonArray[3]["Negative Approved"];

    function get(k) {
      return approvedMap[k];
    }

    clearedMap = jsonArray[4]["Positive Cleared"];
    negativeClearedMap = jsonArray[5]["Negative Cleared"];
    function get(k) {
      return clearedMap[k];
    }

    if (enableForecast) {
      $("#forecast-box").show();
      forecastMap = jsonArray[6]["Positive Forecast"];
      negativeForecastMap = jsonArray[7]["Negative Forecast"];
      function get(k) {
        return forecastMap[k];
      }
    }


    var reviewDateArray = [];
    var approvedDateArray = [];
    var clearedDateArray = [];
    var forecastDateArray = [];

    var reviewArray = [];
    var negativeReviewArray = [];
    var approvedArray = [];
    var negativeApprovedArray = [];
    var clearedArray = [];
    var negativeClearedArray = [];
    var forecastArray = [];
    var negativeForecastArray = [];

    var reviewkeys = Object.keys(map);
    var negativeReviewkeys = Object.keys(negativeMap);
    var approvedkeys = Object.keys(approvedMap);
    var negativeApprovedkeys = Object.keys(negativeApprovedMap);
    var clearedKeys = Object.keys(clearedMap);
    var negativeClearedKeys = Object.keys(negativeClearedMap);
    var forecastKeys = Object.keys(forecastMap);
    var negativeForecastKeys = Object.keys(negativeForecastMap);

    var reviewValues = Object.values(map);
    var negativeReviewValues = Object.values(negativeMap);
    var approvedValues = Object.values(approvedMap);
    var negativeApprovedValues = Object.values(negativeApprovedMap);
    var clearedValues = Object.values(clearedMap);
    var negativeClearedValues = Object.values(negativeClearedMap);
    var forecastValues = Object.values(forecastMap);
    var negativeForecastValues = Object.values(negativeForecastMap);

    var disallowedDownload =
      reviewValues.length == 0 &&
      negativeReviewValues.length == 0 &&
      approvedValues.length == 0 &&
      negativeApprovedValues.length == 0 &&
      clearedValues.length == 0 &&
      negativeClearedValues.length == 0 &&
      forecastValues.length == 0 &&
      negativeForecastValues.length == 0;

    if (disallowedDownload) {
      $("#downloadButton").attr("disabled", "disabled");
      $("#downloadInterestButton").attr("disabled", "disabled");
    } else {
      $("#downloadButton").removeAttr("disabled");
      $("#downloadInterestButton").removeAttr("disabled");
    }

    var negativeDateArray = negativeReviewkeys.concat(negativeApprovedkeys);
    negativeDateArray = negativeDateArray.concat(negativeClearedKeys);
    if (enableForecast) {
      negativeDateArray = negativeDateArray.concat(negativeForecastKeys);
    }

    var fullDateArray = reviewkeys.concat(approvedkeys);
    fullDateArray = fullDateArray.concat(clearedKeys);
    if (enableForecast) {
      fullDateArray = fullDateArray.concat(forecastKeys);
    }
    fullDateArray = fullDateArray.concat(negativeDateArray);

    var uniquefullDateArray = [];
    $.each(fullDateArray, function (i, el) {
      if ($.inArray(el, uniquefullDateArray) === -1)
        uniquefullDateArray.push(el);
    });

    var months = {
      Jan: 1,
      Feb: 2,
      Mar: 3,
      Apr: 4,
      May: 5,
      Jun: 6,
      Jul: 7,
      Aug: 8,
      Sep: 9,
      Oct: 10,
      Nov: 11,
      Dec: 12,
    };

    var arrayDate = [];
    for (var i in uniquefullDateArray) {
      var d = uniquefullDateArray[i].split(" ");
      for (var j in months) {
        if (d[0] == j) {
          arrayDate.push(1 + "/" + months[j] + "/" + d[1]);
        }
      }
    }
    arrayDate.sort(function (dateA, dateB) {
      return new Date(dateA) - new Date(dateB);
    });

    var newUniqueDateArray = [];

    for (var i in arrayDate) {
      var d = arrayDate[i].split("/");
      for (var j in months) {
        if (d[1] == months[j]) {
          newUniqueDateArray.push(j + " " + d[2]);
        }
      }
    }

    for (var i = 0; i < newUniqueDateArray.length; i++) {
      reviewArray[i] = 0;
      negativeReviewArray[i] = 0;
      approvedArray[i] = 0;
      negativeApprovedArray[i] = 0;
      clearedArray[i] = 0;
      negativeClearedArray[i] = 0;
      forecastArray[i] = 0;
      negativeForecastArray[i] = 0;
    }

    reviewArray = getSortedValues(newUniqueDateArray, map);
    negativeReviewArray = getSortedValues(newUniqueDateArray, negativeMap);

    approvedArray = getSortedValues(newUniqueDateArray, approvedMap);
    negativeApprovedArray = getSortedValues(
      newUniqueDateArray,
      negativeApprovedMap,
    );

    clearedArray = getSortedValues(newUniqueDateArray, clearedMap);
    negativeClearedArray = getSortedValues(
      newUniqueDateArray,
      negativeClearedMap,
    );

    forecastArray = getSortedValues(newUniqueDateArray, forecastMap);
    negativeForecastArray = getSortedValues(
      newUniqueDateArray,
      negativeForecastMap,
    );

    Chart.defaults.scale.ticks.beginAtZero = true;
    var barChartData = {
      labels: newUniqueDateArray,
      datasets: [
        {
          label: "In-review",
          backgroundColor: window.chartColors.yellow,
          data: reviewArray,
        },
        {
          label: "In-review",
          backgroundColor: window.chartColors.yellow,
          data: negativeReviewArray,
          //                				hidden: false
        },
        {
          label: "Approved",
          backgroundColor: window.chartColors.orange,
          data: approvedArray,
        },
        {
          label: "Approved",
          backgroundColor: window.chartColors.orange,
          data: negativeApprovedArray,
        },
        {
          label: "Cleared",
          backgroundColor: window.chartColors.green,
          data: clearedArray,
        },
        {
          label: "Cleared",
          backgroundColor: window.chartColors.green,
          data: negativeClearedArray,
        },
        {
          label: "Forecast",
          backgroundColor: window.chartColors.blue,
          data: forecastArray,
        },
        {
          label: "Forecast",
          backgroundColor: window.chartColors.blue,
          data: negativeForecastArray,
        },
      ],
    };

    var ctx = document.getElementById("barChart").getContext("2d");
    if (window.myBar != undefined) {
      window.myBar.destroy();
    }

    window.myBar = new Chart(ctx, {
      type: "bar",
      data: barChartData,
      options: {
        title: {
          display: true,
          text: "Monthly summary of transactions",
        },
        legend: {
          labels: {
            filter: function (legendItem, chartData) {
              if (legendItem.datasetIndex === 6) {
                if (!enableForecast) {
                  return false;
                }
              }
              if (legendItem.datasetIndex === 0) {
                if (!enableReview) {
                  return false;
                }
              }
              if (
                legendItem.datasetIndex === 1 ||
                legendItem.datasetIndex === 3 ||
                legendItem.datasetIndex === 5 ||
                legendItem.datasetIndex === 7
              ) {
                return false;
              }
              return true;
            },
          },
          onClick: function (e, legendItem) {
            var index = legendItem.datasetIndex;
            var ci = this.chart;
            var alreadyHidden =
              ci.getDatasetMeta(index).hidden === null
                ? false
                : ci.getDatasetMeta(index).hidden;
            var anyOthersAlreadyHidden = false;
            var allOthersHidden = true;

            // figure out the current state of the labels
            ci.data.datasets.forEach(function (e, i) {
              var meta = ci.getDatasetMeta(i);

              if (i !== index) {
                if (meta.hidden) {
                  anyOthersAlreadyHidden = true;
                } else {
                  allOthersHidden = false;
                }
              }
            });

            // if the label we clicked is already hidden
            // then we now want to unhide (with any others already unhidden)
            if (alreadyHidden) {
              ci.getDatasetMeta(index).hidden = null;
              ci.getDatasetMeta(index + 1).hidden = null;
            } else {
              // otherwise, lets figure out how to toggle visibility based upon the current state
              ci.data.datasets.forEach(function (e, i) {
                var meta = ci.getDatasetMeta(i);
                var negMeta;

                if (i == index) {
                  negMeta = ci.getDatasetMeta(i + 1);
                  // handles logic when we click on visible hidden label and there is currently at least
                  // one other label that is visible and at least one other label already hidden
                  // (we want to keep those already hidden still hidden)
                  if (anyOthersAlreadyHidden && !allOthersHidden) {
                    meta.hidden = true;
                    negMeta.hidden = true;
                  } else {
                    // toggle visibility
                    meta.hidden = meta.hidden === null ? !meta.hidden : null;
                    negMeta.hidden =
                      negMeta.hidden === null ? !negMeta.hidden : null;
                  }
                }
              });
            }

            ci.update();
          },
        },
        tooltips: {
          mode: "index",
          intersect: false,
          callbacks: {
            label: function (tooltipItem, data) {
              var label;
              if (tooltipItem.datasetIndex == 0) {
                label = "In review payments";
              }
              if (tooltipItem.datasetIndex == 1) {
                label = "In-review receipts";
              }
              if (tooltipItem.datasetIndex == 2) {
                label = "Approved payments";
              }
              if (tooltipItem.datasetIndex == 3) {
                label = "Approved receipts ";
              }
              if (tooltipItem.datasetIndex == 4) {
                label = "Cleared payments";
              }
              if (tooltipItem.datasetIndex == 5) {
                label = "Cleared receipts";
              }
              if (tooltipItem.datasetIndex == 6) {
                label = "Forecast payments";
              }
              if (tooltipItem.datasetIndex == 7) {
                label = "Forecast receipts";
              }
              //                                                            var label = data.datasets[tooltipItem.datasetIndex].label || '';
              var labelVal = tooltipItem.yLabel;

              if (label) {
                label += ": ";
              }
              if (isNaN(labelVal)) {
                label = "";
              } else {
                if (parseInt(labelVal) >= 1000 || parseInt(labelVal) <= -1000) {
                  label +=
                    "£" +
                    labelVal.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                } else {
                  label += "£" + labelVal;
                }
              }

              return label;
            },
          },
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [
            {
              stacked: true,
            },
          ],
          yAxes: [
            {
              stacked: true,
              ticks: {
                beginAtZero: true,
                callback: function (value, index, values) {
                  if (
                    parseInt(value) >= 1000000 ||
                    parseInt(value) <= -1000000
                  ) {
                    var val = value / 1000000;
                    if (val >= 1000 || val <= -1000) {
                      return (
                        "£" +
                        val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
                        "M"
                      );
                    } else {
                      return "£" + value / 1000000 + "M";
                    }
                  } else if (
                    (parseInt(value) >= 1000 && parseInt(value) < 1000000) ||
                    (parseInt(value) <= -1000 && parseInt(value) > -1000000)
                  ) {
                    return "£" + value / 1000 + "K";
                  } else {
                    return "£" + value;
                  }
                },
              },
              scaleLabel: {
                display: true,
                labelString: "Amount (£)",
              },
            },
          ],
        },
      }
    });
  },
};

function getSortedValues(newUniqueDateArray, map) {
  var mapKeys = Object.keys(map);
  var mapValues = Object.values(map);
  var sortedArray = [];

  for (var i = 0; i < newUniqueDateArray.length; i++) {
    for (var j = 0; j < mapValues.length; j++) {
      if (newUniqueDateArray[i] == mapKeys[j]) {
        sortedArray[i] = mapValues[j];
      }
    }
  }
  return sortedArray;
}
